import { ApiBaseResponse } from "hooks/axios/interfaces";
import { useRequest } from "hooks/axios/useRequest";

interface ApiPostResponse<BodyType, ResponseType> extends ApiBaseResponse {
  postCallback: (bodyType: BodyType) => Promise<ResponseType | undefined>;
}

export function usePost<BodyType, ResponseType, ParamsType = undefined>(
  url: string,
  params?: ParamsType
): ApiPostResponse<BodyType, ResponseType> {
  const { loading, error, requestCallback } = useRequest<
    ResponseType,
    ParamsType,
    BodyType
  >("POST", url, params);

  return {
    loading,
    error,
    postCallback: requestCallback
  };
}
